import React from 'react';
import { Card } from '../Card/Card';

interface AdoptionsCardSkeletonProps {
  className?: string;
}

export const AdoptionsCardSkeleton: React.FC<AdoptionsCardSkeletonProps> = ({ className = '' }) => {
  return (
    <Card
      background="white"
      radius="large"
      padding="none"
      className={`border border-black/20 ${className}`}
    >
      <div className="flex flex-col gap-12 p-12">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="h-9 w-64 bg-gray-200 rounded-lg animate-pulse" />

          {/* Legend */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-200 animate-pulse" />
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-200 animate-pulse" />
              <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-200 animate-pulse" />
              <div className="h-4 w-18 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-200 animate-pulse" />
              <div className="h-4 w-14 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex justify-between items-end gap-54">
          {/* Metrics */}
          <div className="flex flex-col gap-3">
            <div className="h-24 w-40 bg-gray-200 rounded-lg animate-pulse" />
            <div className="flex items-center gap-1">
              <div className="h-4 w-44 bg-gray-200 rounded animate-pulse" />
              <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>

          {/* Chart */}
          <div className="h-[314px] w-[500px] bg-gray-200 rounded-lg animate-pulse" />
        </div>
      </div>
    </Card>
  );
};

export default AdoptionsCardSkeleton;
